export enum SchoolTableTypes {
	Approved = 'approved',
	Pending = 'pending',
	Denied = 'denied',
}